import { PaymentType, type PaymentRead } from "@/api-v3";

/** A claim with no participant creator was raised by a User on the participant's behalf. */
export const claimRaisedByStudyTeam = (claim: {
  created_by_participant_id?: string | null;
}): boolean => claim.created_by_participant_id == null;

/** Stipends and micropayments never have a participant creator, so only claims count. */
export const raisedByStudyTeam = (
  payment: Pick<PaymentRead, "type" | "created_by_participant_id">
): boolean =>
  (payment.type === PaymentType.receipt_claim ||
    payment.type === PaymentType.mileage_claim) &&
  claimRaisedByStudyTeam(payment);
